module.exports = __webpack_public_path__ + "static/img/alexa.11d6dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alexa.png
// module id = apOX
// module chunks = 1